(function () {
  'use strict';

  function formatValue(val) {
    if (val === null || val === undefined || val === '') return null;
    return val;
  }

  function displayValue(val, field) {
    if (formatValue(val) === null) return '';

    if (field === 'coverage_sqft') return Number(val).toFixed(1) + ' sq. ft';
    if (field === 'width_in') return val + ' Wide';
    if (field === 'length_ft') return val + ' ft';
    if (field === 'width_ft') return val + ' ft';

    return val;
  }

  function comboLabel(product, fieldA, fieldB) {
    var parts = [];
    if (fieldA && formatValue(product[fieldA]) !== null) {
      parts.push(displayValue(product[fieldA], fieldA));
    }
    if (fieldB && formatValue(product[fieldB]) !== null) {
      parts.push(displayValue(product[fieldB], fieldB));
    }
    return parts.join(' ');
  }

  function sizeButtonHtml(product, fieldA, fieldB) {
    var primary = fieldA ? formatValue(product[fieldA]) : null;
    var secondary = fieldB ? formatValue(product[fieldB]) : null;
    var primaryText = primary !== null ? displayValue(primary, fieldA) : '';
    var secondaryText = secondary !== null ? displayValue(secondary, fieldB) : '';

    return '<span class="sq">' + primaryText + '</span>' +
           (secondaryText ? '<span class="dim">' + secondaryText + '</span>' : '');
  }

  function comboKey(product, fields) {
    return (fields.a ? product[fields.a] : '') + '::' + (fields.b ? product[fields.b] : '');
  }

  function numericOrStringSort(a, b, field) {
    var an = parseFloat(a[field]);
    var bn = parseFloat(b[field]);
    if (!isNaN(an) && !isNaN(bn)) return an - bn;
    return String(a[field] || '').localeCompare(String(b[field] || ''));
  }

  function initSelector(root) {
    var jsonEl = root.querySelector('[data-role="heating-selector-json"]');
    if (!jsonEl) return;

    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!data.length) return;

    var current = data.find(function (p) { return p.current; }) || data[0];
    var groups = [
      {
        role: 'group1',
        a: root.dataset.group1A,
        b: root.dataset.group1B,
        type: 'pill'
      },
      {
        role: 'group2',
        a: root.dataset.group2A,
        b: root.dataset.group2B,
        type: root.dataset.group3A ? 'pill' : 'size'
      }
    ];

    if (root.dataset.group3A) {
      groups.push({
        role: 'group3',
        a: root.dataset.group3A,
        b: root.dataset.group3B,
        type: 'size'
      });
    }

    var state = {};
    groups.forEach(function (group, index) {
      state[index] = {
        a: group.a && current[group.a] != null ? current[group.a] : null,
        b: group.b && current[group.b] != null ? current[group.b] : null
      };
    });

    function fieldsMatch(p, group, values) {
      if (group.a && p[group.a] !== values.a) return false;
      if (!group.b) return true;
      return p[group.b] === values.b;
    }

    function matchesThrough(p, groupIndex) {
      for (var i = 0; i <= groupIndex; i++) {
        if (!fieldsMatch(p, groups[i], state[i])) return false;
      }
      return true;
    }

    function matchesBefore(p, groupIndex) {
      for (var i = 0; i < groupIndex; i++) {
        if (!fieldsMatch(p, groups[i], state[i])) return false;
      }
      return true;
    }

    function orderedCombos(group, products) {
      var seen = {};
      var combos = [];
      products.forEach(function (p) {
        var key = comboKey(p, group);
        if (!seen[key]) {
          seen[key] = true;
          combos.push(p);
        }
      });

      combos.sort(function (a, b) {
        return numericOrStringSort(a, b, group.a) || (group.b ? numericOrStringSort(a, b, group.b) : 0);
      });
      return combos;
    }

    function sortedProductsForGroup(group, products) {
      return products.slice().sort(function (a, b) {
        return numericOrStringSort(a, b, group.a) || (group.b ? numericOrStringSort(a, b, group.b) : 0);
      });
    }

    function sortByGroups(products, startIndex) {
      return products.slice().sort(function (a, b) {
        for (var i = startIndex; i < groups.length; i++) {
          var group = groups[i];
          var result = numericOrStringSort(a, b, group.a) || (group.b ? numericOrStringSort(a, b, group.b) : 0);
          if (result !== 0) return result;
        }
        return 0;
      });
    }

    function syncStateFromProduct(product) {
      groups.forEach(function (group, index) {
        state[index].a = group.a ? product[group.a] : null;
        state[index].b = group.b ? product[group.b] : null;
      });
    }

    function renderGroup(groupIndex) {
      var group = groups[groupIndex];
      var groupEl = root.querySelector('[data-role="' + group.role + '"]');
      if (!groupEl) return;

      groupEl.innerHTML = '';
      var availableProducts = data.filter(function (p) {
        return matchesBefore(p, groupIndex);
      });
      var products = group.type === 'size'
        ? sortedProductsForGroup(group, availableProducts)
        : orderedCombos(group, availableProducts);

      products.forEach(function (p) {
        var btn = document.createElement('button');
        var active = fieldsMatch(p, group, state[groupIndex]);
        btn.type = 'button';
        btn.className = (group.type === 'size' ? 'size-btn' : 'vw-btn') + (active ? ' active' : '');
        if (group.type === 'size') {
          btn.innerHTML = sizeButtonHtml(p, group.a, group.b);
        } else {
          btn.textContent = comboLabel(p, group.a, group.b);
        }

        btn.addEventListener('click', function () {
          state[groupIndex].a = group.a ? p[group.a] : null;
          state[groupIndex].b = group.b ? p[group.b] : null;

          var matches = data.filter(function (candidate) {
            return matchesThrough(candidate, groupIndex);
          });
          var orderedMatches = sortByGroups(matches, groupIndex + 1);
          var target = orderedMatches[0] || p;

          if (target.id !== current.id) {
            sessionStorage.setItem('heatingSelectorScroll', '1');
            window.location.href = target.url;
            return;
          } 
          syncStateFromProduct(target);
          renderAll();
        });

        groupEl.appendChild(btn);
      });
    }

    function renderAll() {
      groups.forEach(function (_group, index) {
        renderGroup(index);
      });
    }

    renderAll();
      // Auto scroll after page navigation
      // if (sessionStorage.getItem('heatingSelectorScroll')) {
      //   sessionStorage.removeItem('heatingSelectorScroll');

      //   requestAnimationFrame(function () {
      //     setTimeout(function () {
      //       var isMobile = window.innerWidth < 750;
      //       var offset = isMobile ? 140 : 0;

      //       var top = root.getBoundingClientRect().top + window.pageYOffset - offset;

      //       window.scrollTo({
      //         top: top,
      //         behavior: 'smooth'
      //       });
      //     }, 200);
      //   });
      // }
      if (sessionStorage.getItem('heatingSelectorScroll')) {
        sessionStorage.removeItem('heatingSelectorScroll');

        if (window.innerWidth < 750) {
          setTimeout(function () {
            var top = root.getBoundingClientRect().top + window.pageYOffset - 140;

            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });
          }, 500);
        }
      }
  }

  function init() {
    document.querySelectorAll('.heating-line-selector').forEach(initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();